.searchCard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  transition: background 0.3s ease;
  position: relative;

  > a, > div {
    flex: 1;
    padding: 12px 24px;

    .phone &,
    .tablet & {
      padding: 12px 16px;
    }
  }

  .clearBtn {
    all: unset;
    cursor: pointer;
    display: block;
    width: 20px;
    height: 20px;
    opacity: 0;
    transition: opacity 0.3s ease;
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);

    svg {
      width: 20px;
      height: 20px;
    }

    .phone &,
    .tablet & {
      opacity: 1;
    }
  }

  &:hover {
    background: var(--primitives-colors-neutral-970);

    .clearBtn {
      opacity: 1;
    }
  }

  .profileCardInfo {
    margin-right: 12px;
  }

  .searchedPart {
    --highlighted-text-font: var(--p1-medium);
    --highlighted-text-color: var(--white);
  }
}
